export default __webpack_public_path__ + "static/media/TherapyValues.28db2902.png";